import { observer } from 'mobx-react-lite';
import { PropsWithChildren, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { BasePage, BasePageProps, PageType } from 'src/components/BasePage';
import { NotFound } from 'src/components/Errors/NotFound';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { Entity } from 'src/utils/mobx/BasicStore/BasicStore.types';

type DetailsPageProps = PropsWithChildren<
    Pick<BasePageProps, 'pageName' | 'isLoading' | 'headerTopPanel'> & {
        store: BasicStore<Entity>;
    }
>;

export const DetailsPage = observer(
    ({
        pageName,
        store,
        isLoading,
        headerTopPanel,
        children,
    }: DetailsPageProps) => {
        const {
            params: { id },
        } = useRouteMatch<{ id: string }>();

        useEffect(() => {
            store.loadItem(id);

            return () => {
                store.itemLoader.reset();
            };
        }, []);

        if (store.itemLoader?.errorData?.status === 404) {
            return <NotFound />;
        }

        return (
            <BasePage
                showOnlyLoading
                isLoading={store.itemLoader.isLoading || isLoading}
                pageName={`${pageName}-${id}`}
                type={PageType.BASE}
                data-testid={`${pageName}-${id}`}
                headerTopPanel={headerTopPanel}
            >
                {children}
            </BasePage>
        );
    },
);
